import React from 'react';
import { Link } from 'react-router-dom';
import { Label } from 'semantic-ui-react';
import { buildPosVendaProtocoloUrl } from '../../utils/clientCancellationLines/clientCancellationProtocolLink';

export interface ClientCancellationProtocolLinkProps {
  protocolId?: string | null;
  protocolNumber?: string | null;
  clientId?: string | null;
  size?: 'small' | 'medium';
}

export const ClientCancellationProtocolLink: React.FC<ClientCancellationProtocolLinkProps> = ({
  protocolId,
  protocolNumber,
  clientId,
  size = 'small',
}) => {
  if (!protocolId?.trim()) return null;
  const label = protocolNumber?.trim() || 'Ver protocolo';
  return (
    <Link
      to={buildPosVendaProtocoloUrl(protocolId, { clientId })}
      title="Abrir protocolo pós-venda"
      style={{ display: 'inline-block' }}
    >
      <Label color="blue" size={size} style={{ cursor: 'pointer' }}>
        {label}
      </Label>
    </Link>
  );
};

export default ClientCancellationProtocolLink;
